import { useHasHome } from '../hooks/useHasHome';
import { useHomeAccess } from '../hooks/useHomeAccess';
import { useIsHomePageActive } from '../hooks/useIsHomePageActive';

export function useHomeOwnsWelcome() {
  const hasHome = useHasHome();
  const { isLoading } = useHomeAccess();
  const isHomePageActive = useIsHomePageActive();
  return {
    homeOwnsWelcome: hasHome && isHomePageActive,
    isPending: hasHome && isLoading,
  };
}
